import { render, staticRenderFns } from "./base_image_diff_overlay.vue.js?vue&type=template&id=0e58d1d9&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./base_image_diff_overlay.vue?vue&type=template&id=0e58d1d9&vue3"
import script from "./base_image_diff_overlay.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./base_image_diff_overlay.vue?vue&type=script&lang=js&vue3"
export * from "./base_image_diff_overlay.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./base_image_diff_overlay.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports